import { warehouseClient } from "@/infrastructure/http/warehouseClient";
import type { ApiEnvelope } from "@/domain/types";

interface ProductLookupResult {
  found: boolean;
  product: {
    id: string;
    code: string;
    name: string;
    typeUnitId: string;
    status: string;
  } | null;
}

interface LocationLookupResult {
  found: boolean;
  location: {
    id: string;
    locationCode: string;
    warehouseId: string;
    isleId: string;
    section: string;
    level: string;
    position: string;
    capacity: number | null;
    status: string;
  } | null;
}

export async function lookupProduct(barcode: string): Promise<ProductLookupResult> {
  const response = await warehouseClient.get<ApiEnvelope<ProductLookupResult>>(`/product/lookup?barcode=${encodeURIComponent(barcode)}`);
  return response.data.data ?? { found: false, product: null };
}

export async function lookupLocation(code: string): Promise<LocationLookupResult> {
  const response = await warehouseClient.get<ApiEnvelope<LocationLookupResult>>(`/location/lookup?code=${encodeURIComponent(code)}`);
  return response.data.data ?? { found: false, location: null };
}
